import { number } from 'prop-types';

const deliveryPriceConfigurationBasicInformationPropTypes = {
  minKilograms: number.isRequired,
  maxKilograms: number.isRequired,
};

export default deliveryPriceConfigurationBasicInformationPropTypes;
